import { initialState } from './state'
import {
  setOnlineStatusRoutine,
  updateSyncCountsRoutine,
  syncProgressRoutine,
  syncCompleteRoutine,
  syncErrorRoutine,
  clearSyncErrorsRoutine,
  syncFailRoutine
} from './actions'
import { logoutUserRoutine } from 'features/auth/ducks/actions'

const offlineReducer = (state = initialState, action) => {
  switch (action.type) {
    case setOnlineStatusRoutine.SUCCESS:
      return { ...state, isOnline: action.payload.isOnline }

    case updateSyncCountsRoutine.SUCCESS:
      return {
        ...state,
        syncQueueCount: action.payload.syncQueueCount,
        pendingFileCount: action.payload.pendingFileCount,
        pendingFileSizeMb: action.payload.pendingFileSizeMb
      }

    case syncProgressRoutine.SUCCESS:
      return {
        ...state,
        isSyncing: true,
        syncProgress: action.payload
      }

    case syncCompleteRoutine.SUCCESS:
      return {
        ...state,
        isSyncing: false,
        syncProgress: null,
        lastSyncedAt: new Date().toISOString()
      }

    case syncErrorRoutine.SUCCESS:
      return {
        ...state,
        syncErrors: [...state.syncErrors, action.payload]
      }

    case clearSyncErrorsRoutine.SUCCESS:
      return { ...state, syncErrors: [] }

    case syncFailRoutine.SUCCESS:
      return {
        ...state,
        isSyncing: false,
        syncProgress: null
      }

    case logoutUserRoutine.SUCCESS:
      return { ...initialState }

    default:
      return state
  }
}

export default offlineReducer
